// Form send url
export const FORM_URL = process.env.REACT_APP_WINTERSOLDIER_ENDPOINT_FORM || "";

export const COUNTRY_DETECTOR = process.env.REACT_APP_COUNTRY_DETECTOR || "";

export const OPEN_COUNTRIES = [
  { code: "AR", label: "Argentina" },
  { code: "CL", label: "Chile" },
  { code: "MX", label: "Mexico" },
  { code: "PE", label: "Peru" },
  { code: "UY", label: "Uruguay" },
  { code: "GT", label: "Guatemala" },
  { code: "EC", label: "Ecuador" },
];
